import React, { useState, useEffect, useContext } from 'react';
import { useNavigate } from 'react-router-dom';
import api from '../api';
import { AuthContext } from '../App';
import SummaryCards from '../components/SummaryCards';
import AlertsBar from '../components/AlertsBar';
import SitesTable from '../components/SitesTable';

export default function Dashboard() {
  const navigate = useNavigate();
  const [data, setData] = useState(null);
  const [alerts, setAlerts] = useState([]);
  const [search, setSearch] = useState('');
  // Default to active sites only — paused/frozen sites must not clutter the main
  // screen. They stay reachable via the "הכל"/"מושהים" filter chips below.
  const [statusFilter, setStatusFilter] = useState('active');
  const [promoterFilter, setPromoterFilter] = useState('');
  const [loading, setLoading] = useState(true);
  var auth = useContext(AuthContext);
  var [myOnly, setMyOnly] = useState(false);

  useEffect(() => {
    loadData();
  }, []);

  async function loadData() {
    setLoading(true);
    try {
      const [summary, alertsData] = await Promise.all([
        api.getPortfolioSummary(),
        api.getPortfolioAlerts().catch(() => ({ alerts: [] })),
      ]);
      setData(summary);
      setAlerts(alertsData.alerts || []);
    } catch (err) {
      console.error('Failed to load portfolio:', err);
    }
    setLoading(false);
  }

  if (loading) return <div className="loading">טוען...</div>;
  if (!data) return <div className="loading">שגיאה בטעינת נתונים</div>;

  // Filter sites
  var filteredSites = data.sites || [];
  if (search) {
    var q = search.toLowerCase();
    filteredSites = filteredSites.filter(function(s) {
      return s.name.toLowerCase().includes(q) ||
        s.url.toLowerCase().includes(q) ||
        (s.client_name && s.client_name.toLowerCase().includes(q));
    });
  }
  if (statusFilter) {
    filteredSites = filteredSites.filter(function(s) { return s.status === statusFilter; });
  }
  if (promoterFilter) {
    filteredSites = filteredSites.filter(function(s) { return s.assigned_to === promoterFilter; });
  }
  if (myOnly && auth && auth.user) {
    filteredSites = filteredSites.filter(function(s) { return s.assigned_to === auth.user.name; });
  }

  var statusFilters = [
    { key: '', label: '\u05d4\u05db\u05dc (' + data.total_sites + ')' },
    { key: 'active', label: '\u05e4\u05e2\u05d9\u05dc\u05d9\u05dd (' + data.active_sites + ')' },
    { key: 'paused', label: '\u05de\u05d5\u05e9\u05d4\u05d9\u05dd (' + data.paused_sites + ')' },
  ];
  if (data.frozen_sites > 0) {
    statusFilters.push({ key: 'frozen', label: '\u05de\u05d5\u05e7\u05e4\u05d0\u05d9\u05dd (' + data.frozen_sites + ')' });
  }

  var promoters = data.promoters || [];

  return (
    <>
      <SummaryCards data={data} />
      <AlertsBar alerts={alerts} />

      <div className="filter-row">
        <div className="topbar-search" style={{ width: '300px' }}>
          <svg width="16" height="16" fill="none" stroke="currentColor" strokeWidth="2">
            <circle cx="7" cy="7" r="5"/><path d="m11 11 3 3"/>
          </svg>
          <input type="text" placeholder="\u05d7\u05d9\u05e4\u05d5\u05e9 \u05d0\u05ea\u05e8, \u05dc\u05e7\u05d5\u05d7..." value={search} onChange={function(e) { setSearch(e.target.value); }} />
        </div>

        {statusFilters.map(function(f) {
          return (
            <div key={f.key} className={'filter-chip ' + (statusFilter === f.key ? 'active' : '')}
              onClick={function() { setStatusFilter(f.key); }}>{f.label}</div>
          );
        })}

        {promoters.length > 0 && (
          <>
            <div className="filter-divider" />
            <div className={'filter-chip ' + (myOnly ? 'active' : '')}
              onClick={function() { setMyOnly(!myOnly); if (!myOnly) setPromoterFilter(''); }}
              style={myOnly ? {background: 'rgba(59,130,246,0.15)', borderColor: 'var(--accent)', color: 'var(--accent)'} : {}}
            >{'האתרים שלי'}</div>
            <div className="filter-divider" />
            <select
              className="filter-select"
              value={promoterFilter}
              onChange={function(e) { setPromoterFilter(e.target.value); }}
            >
              <option value="">{'\u05db\u05dc \u05d4\u05de\u05e7\u05d3\u05de\u05d9\u05dd'}</option>
              {promoters.map(function(p) {
                return <option key={p} value={p}>{p}</option>;
              })}
            </select>
          </>
        )}

        <div className="filter-spacer" />
        <button className="btn-sm primary" onClick={function() { navigate('/add-site'); }}>+ {'\u05d4\u05d5\u05e1\u05e4\u05ea \u05d0\u05ea\u05e8'}</button>
      </div>

      <SitesTable sites={filteredSites} />
    </>
  );
}
